import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DIALOG_TITLES } from '../../../constants';
import { useAppointmentForm, useCalendar, useDialogs } from '../../../hooks';
import Form from './Form';

const AppointmentFormDialog = () => {
  const [title, setTitle] = useState(DIALOG_TITLES.appointment.create);

  const { addAppointment: onCreate, updateAppointment: onUpdate } = useCalendar();

  const {
    activeAppointment,
    showAppointmentFormDialog: isOpen,
    handleCloseAppointmentFormDialog: onClose,
  } = useDialogs();

  const { errorMessage, form, handleOpenChange, handleSubmit, isSubmitting } =
    useAppointmentForm({ activeAppointment, onClose, onCreate, onUpdate });

  useEffect(() => {
    if (isOpen) {
      setTitle(
        activeAppointment
          ? DIALOG_TITLES.appointment.update
          : DIALOG_TITLES.appointment.create
      );
    }
  }, [activeAppointment, isOpen]);

  return (
    <Dialog onOpenChange={handleOpenChange} open={isOpen}>
      <DialogContent className="space-y-4">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <Form
          activeAppointment={activeAppointment}
          errorMessage={errorMessage}
          form={form}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AppointmentFormDialog;
